import * as React from "react";
import './FormFinancials.css';
import FormStepper from "../../../components/FormStepper/FormStepper";
import {observer} from "mobx-react";
import LottieAnimation from "../../../../../components/LottieAnimation/LottieAnimation";
import ResetFormBtn from "../../../../../components/ResetForm/resetFormBtn";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import {LeadInstallmentOptions} from "shared/functions/membersApi/types/ISignupProcess";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";

interface IProps {
    store: any;
    isInstallmentSelected: (val:number) => boolean;
    onInstallmentSelect: (val: number) => void;
    steps: any[];
    isLendio?: boolean;
}

interface ILocalState {
    selectedOption: number | undefined;
    selectedInstallmentPlan: LeadInstallmentOptions | undefined;
}
const storePropertyName = "financial";

@observer
export default class FormFinancial  extends React.Component<
    IProps,
    ILocalState
    > {

    public lendioReasonSelected = (val: string) => {
        this.props.store.formInput[storePropertyName].fundReason = val;
    };

    public onDepositPaidClick = (val: number) => {
        const {store} = this.props;
        if (val === 1) {
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.Waive);
            store.formInput[storePropertyName].isDepositPaid = true;
            this.setState({selectedOption: 1});
        }else {
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.Reeedem);
            store.formInput[storePropertyName].isDepositPaid = false;
            this.setState({selectedOption: 2});
        }
    };


    public render() {
        const {store, steps} = this.props;
            {return store.showVerifiedCheckmark?
            <div className="lottie-container">
            <LottieAnimation animationName={'greenCheckmark'}/>
                <div className="verified-text"> Your account is now connected </div>
            </div>
            :
            <>
                <FormStepper navigationProperty={storePropertyName} steps={steps} store={store}/>
                {store.plaidError? <div className="plaid-error">Our bad! there was an error connecting your Bank account, please try again later</div> : null}
                {store.showResetFormButton? <div className="form-navigation"> <ResetFormBtn/> </div>: null}
            </>
        }
    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormFinancial/FormFinancial.tsx